export default __webpack_public_path__ + "static/media/attendance_banner.7aae69c7.png";